export default __webpack_public_path__ + "static/media/trv_1.7ba90f6b.jpg";